import personalLoanCalculatorApi from '../../api/personal-loan-calculator-api';
const PERSONAL_LOAN_CALCULATOR_CONFIG_RESPONSE = 'personalLoanCalculatorConfigResponse';
const PERSONAL_LOAN_CALCULATOR_CONFIG_FAILURE = 'personalLoanCalculatorConfigFailure';
const PERSONAL_LOAN_CALCULATOR_LOAN_SELECT_RESPONSE = 'personalLoanCalculatorLoanSelectResponse';
const PERSONAL_LOAN_CALCULATOR_LOAN_SELECT_FAILURE = 'personalLoanCalculatorLoanSelectFailure';
const PERSONAL_LOAN_CALCULATOR_AMOUNT_CALCULATION_RESPONSE = 'personalLoanCalculatorAmountCalculationResponse';
const PERSONAL_LOAN_CALCULATOR_AMOUNT_CALCULATION_FAILURE = 'personalLoanCalculatorAmountCalculationFailure';
const PERSONAL_LOAN_INTEREST_LIST_RESPONSE = 'personalLoanInterestListResponse';
const PERSONAL_LOAN_INTEREST_LIST_FAILURE = 'personalLoanInterestTypeFailure';
const PERSONAL_LOAN_CALCULATOR_MONTHLY_FEE_CALCULATION_FAILURE = 'personalLoanCalculatorMonthlyFeeCalculationFailure';
const PERSONAL_LOAN_CALCULATOR_SET_CALCULATION_AMOUNT_FORM_DATA = 'personalLoanCalculatorSetAmountCalculationFormData';
const PERSONAL_LOAN_CALCULATOR_SET_CALCULATION_MONTHLY_FEE_FORM_DATA = 'personalLoanCalculatorSetMonthlyFeeCalculationFormData';

const personalLoanCalculatorState = {
	loading: false,
	technicalError: false,
	initConfigData: null,
	selectData: [],
	loanCalculationResponse: null,
	interestListResponse: null,
	calculationAmountFormData: null,
	calculationMonthlyFeeFormData: null
};

const personalLoanCalculatorActions = {
	getConfig({ commit }) {
		return new Promise((resolve, reject) => {
			personalLoanCalculatorApi
				.getConfig()
				.then((response) => {
					commit(PERSONAL_LOAN_CALCULATOR_CONFIG_RESPONSE, response.data);
					resolve();
				})
				.catch((error) => {
					commit(PERSONAL_LOAN_CALCULATOR_CONFIG_FAILURE, error.data);
					reject();
				});
		});
	},
	getSelectValues({ commit }) {
		personalLoanCalculatorApi
			.getSelectValues()
			.then((response) => {
				commit(PERSONAL_LOAN_CALCULATOR_LOAN_SELECT_RESPONSE, response.data);
			})
			.catch((error) => {
				commit(PERSONAL_LOAN_CALCULATOR_LOAN_SELECT_FAILURE, error.data);
			});
	},
	calculateAmount({ commit, state }, params) {
		if (state.initConfigData && state.initConfigData.uuid) {
			commit(PERSONAL_LOAN_CALCULATOR_SET_CALCULATION_AMOUNT_FORM_DATA, params);
			personalLoanCalculatorApi
				.calculateAmount(Object.assign({}, params, { uuid: state.initConfigData.uuid }))
				.then((response) => {
					commit(PERSONAL_LOAN_CALCULATOR_AMOUNT_CALCULATION_RESPONSE, response.data);
				})
				.catch((error) => {
					commit(PERSONAL_LOAN_CALCULATOR_AMOUNT_CALCULATION_FAILURE, error.data);
				});
		}
	},
	setInterestList({ commit }, interestListResponse) {
		commit(PERSONAL_LOAN_INTEREST_LIST_RESPONSE, interestListResponse);
	},
	sendTa(context, taData) {
		personalLoanCalculatorApi.sendTa(taData);
	}
};

const personalLoanCalculatorMutations = {
	[PERSONAL_LOAN_CALCULATOR_CONFIG_RESPONSE](state, data) {
		state.initConfigData = data;
		state.loading = false;
	},
	[PERSONAL_LOAN_CALCULATOR_CONFIG_FAILURE](state) {
		state.technicalError = true;
		state.loading = false;
	},
	[PERSONAL_LOAN_CALCULATOR_LOAN_SELECT_RESPONSE](state, data) {
		state.selectData = data;
		state.loading = false;
	},
	[PERSONAL_LOAN_CALCULATOR_LOAN_SELECT_FAILURE](state) {
		state.technicalError = true;
		state.loading = false;
	},
	[PERSONAL_LOAN_CALCULATOR_AMOUNT_CALCULATION_RESPONSE](state, data) {
		state.loanCalculationResponse = data;
		state.loading = false;
	},
	[PERSONAL_LOAN_CALCULATOR_AMOUNT_CALCULATION_FAILURE](state) {
		state.technicalError = true;
		state.loading = false;
	},
	[PERSONAL_LOAN_INTEREST_LIST_RESPONSE](state, interestListResponse) {
		state.interestListResponse = interestListResponse;
		state.loading = false;
	},
	[PERSONAL_LOAN_INTEREST_LIST_FAILURE](state) {
		state.technicalError = true;
		state.loading = false;
	},
	[PERSONAL_LOAN_CALCULATOR_MONTHLY_FEE_CALCULATION_FAILURE](state) {
		state.technicalError = true;
		state.loading = false;
	},
	[PERSONAL_LOAN_CALCULATOR_SET_CALCULATION_AMOUNT_FORM_DATA](state, calculationAmountFormData) {
		state.calculationAmountFormData = calculationAmountFormData;
	},
	[PERSONAL_LOAN_CALCULATOR_SET_CALCULATION_MONTHLY_FEE_FORM_DATA](state, calculationMonthlyFeeFormData) {
		state.calculationMonthlyFeeFormData = calculationMonthlyFeeFormData;
	}
};

export default {
	namespaced: true,
	state: personalLoanCalculatorState,
	mutations: personalLoanCalculatorMutations,
	actions: personalLoanCalculatorActions
};
